import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Badge } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { ClientsFetchAPI } from '../../../api/Clients';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import Maps from '../../../utils/Maps';
import ModalCreateAddressClient from './ModalCreateAddress';
import ModalViewLocation from './ModalViewLocation';
import { getDireccionMasCercana } from '../../../utils/AddressLocation';
import AlertSmall from '../../Alerts/AlertSmall';
import { useTranslation } from 'react-i18next';


/**
 * ModalAddressClient Component
 * This component handles the modal for managing client addresses.
 * It allows users to view, select, delete, or create new addresses.
 */
function ModalAddressClient({ client_id, addressClient, getAddressClientNow, addressNowLocation, setAddressNowLocation, coordinates, deliverydirect }) {
    const { t } = useTranslation();
    const [showModalAddess, setShowModalAddress] = useState(false); // State to control the visibility of the address modal
    const [modalcreateAddressClient, setModalcreateAddressClient] = useState(false); // State to control the visibility of the create address modal
    const [statusLanguage, setStatusLanguage] = useState(0); // State for language status

    let token = undefined; // Retrieve the token from localStorage
    const [languages, setLanguages] = useState([]); // State for storing languages
    let logo = ""
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
        logo = localStorage.getItem('logo')
    }

    let iconGeneral = ""
    if (localStorage.getItem('iconGeneral') != null || localStorage.getItem('iconGeneral') != undefined || localStorage.getItem('iconGeneral') != "") {
        logo = localStorage.getItem('iconGeneral')
    }

    const [guestClient, setGuestClient] = useState(() => {
        if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
            return localStorage.getItem('guestClient')
        } else {
            return null
        }
    });

    /**
     * Function to delete a client address.
     * Sends a request to the backend to delete the address and updates the UI accordingly.
     */
    const deleteClientAddress = async (address_id) => {

        if (address_id !== undefined) {
            try {
                const response = await ClientsFetchAPI.deleteAddressClient(address_id, token);
                AlertSmall(t('profile.modals.address.deleteSuccess'), "success"); // Show success alert

                // If the deleted address is the currently selected address, remove it from localStorage and state
                if (addressNowLocation !== null) {
                    if (addressNowLocation.id === address_id) {
                        clearAddressLocal()
                    }
                }
                getAddressClientNow(); // Refresh the address list
            } catch (error) {
                ErrorAlert("", error.message, "error"); // Show error alert
            }
        } else {
            clearAddressLocal()
        }

        function clearAddressLocal() {
            localStorage.removeItem("addressNowLocation");
            setAddressNowLocation(null);
        }
    }

    /**
     * Function to select an address.
     * Updates the selected address in localStorage and state, and closes the modal.
     */
    const handleSelectAddress = (address) => {
        localStorage.setItem("addressNowLocation", JSON.stringify(address));
        setAddressNowLocation(address);
        setShowModalAddress(false);
        setModalcreateAddressClient(false);
    }

    /**
     * Function to render the list of addresses.
     * Maps through the address list and displays each address with options to delete or select.
     */
    const viewAddress = () => {
        const listItems = addressClient.map((address, index) => (
            <>
                <div className='col-12 col-md-12  p-2 border rounded-2 m-1'>
                    {/* Card */}
                    <label className="card-restaurant">
                        <span className="plan-details">
                            <div className="">
                                <div className='m-2'>

                                    <div className='row d-flex justify-content-between align-items-center'>
                                        <div className='col-sm d-flex justify-content-center align-items-center col-sm'><ModalViewLocation logo={iconGeneral !== "" ? iconGeneral : logo} address={{ lat: address.lat, lng: address.lng }}></ModalViewLocation></div>
                                        <div className='col-md-8'>
                                            <span className="plan-type" translate='no'>
                                                <i class="uil uil-map-marker"></i> {t('profile.modals.address.addressLabel')} {address.name}  <br></br>
                                                <i class="uil uil-house-user"></i> {t('profile.modals.address.aptLabel')} {address.house_num} <br></br>
                                                <i class="uil uil-phone"></i> {t('profile.modals.address.phoneContactLabel')} {address.phone}
                                            </span>
                                            <p className="plan-description" translate='no'>{t('profile.modals.address.referenceLabel')} {address.additional_info}</p>
                                        </div>
                                    </div>
                                    <div className='row d-flex justify-content-between align-items-center'>
                                        <div className='d-flex justify-content-center align-items-center col-sm'>
                                            <Badge className='w-100 p-2 m-1' onClick={() => deleteClientAddress(address.id)} bg="danger" text="light">
                                                <i class="uil uil-trash-alt"> {t('common.remove')}</i>
                                            </Badge></div>
                                        <div className='d-flex justify-content-center align-items-center col-sm'>
                                            <Badge className='w-100 p-2 m-1' onClick={() => handleSelectAddress(address)} bg="success" text="white">
                                                <i class="uil uil-check"> {t('profile.modals.address.selectAddress')}</i>
                                            </Badge></div>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </label>
                </div>
            </>
        ));
        return (listItems);
    }

    /**
     * Function to handle the closest location.
     * Finds the closest address based on coordinates and selects it.
     */
    const handlerLocation = () => {
        let direction = getDireccionMasCercana(addressClient, coordinates);
        const masCercana = direction.find(addr => addr.closest);

        if (masCercana !== undefined && masCercana !== null) {
            setAddressNowLocation(masCercana);
            localStorage.setItem("addressNowLocation", JSON.stringify(masCercana));
            setShowModalAddress(false);
            AlertSmall(t('profile.modals.address.addressSelected', { name: masCercana.name }), "success");
        } else {
            setModalcreateAddressClient(true); // Open the create address modal
        }
    }

    const valueAddresLength = () => {
        if (addressClient.length == 1) {
            setTimeout(() => {
                setModalcreateAddressClient(true);
            }, 500);
        }
    }

    /**
     * useEffect to handle automatic address selection or creation.
     * Opens the address modal and handles location or address creation based on conditions.
     */
    useEffect(() => {
        if (deliverydirect === true) {
            if (showModalAddess === false) {
                setShowModalAddress(true); // Open the address modal
            }
            //if (addressClient.length > 0) {
            // handlerLocation(); // Handle location if addresses exist
            //} else {
            // Delay the opening of the secondary modal to ensure the parent modal is visible first
            setTimeout(() => {
                setModalcreateAddressClient(true);
            }, 500);
            //}
        }
    }, [deliverydirect, addressClient]);




    return (
        <>
            {/* Main content */}
            <div class="row g-0">
                <div class="col-12 col-md-12">
                    <div class="p-2">
                        {addressNowLocation !== null ? <>
                            <div className='col-12 col-md-12'>
                                {/* Card */}
                                <label className="w-100">
                                    <span className="plan-details">
                                        <div className="">
                                            <div className='m-2'>

                                                <div className='row d-flex justify-content-between align-items-center'>
                                                    <div className='col-sm d-flex justify-content-center align-items-center col-sm'>
                                                        {addressNowLocation !== null ? <ModalViewLocation logo={iconGeneral !== "" ? iconGeneral : logo} address={{ lat: addressNowLocation.lat, lng: addressNowLocation.lng }}></ModalViewLocation> : <ModalViewLocation logo={logo} Address={{ lat: 0, lng: 0 }}></ModalViewLocation>}
                                                    </div>
                                                    <div className='col-md-8'>
                                                        <span className="plan-type" translate='no'>
                                                            <i class="uil uil-map-marker"></i> {t('profile.modals.address.addressLabel')} {addressNowLocation.name}  <br></br>
                                                            <i class="uil uil-house-user"></i> {t('profile.modals.address.aptLabel')} {addressNowLocation.house_num} <br></br>
                                                            <i class="uil uil-phone"></i> {t('profile.modals.address.phoneLabel')} {addressNowLocation.phone}
                                                        </span>
                                                        <p className="plan-description" translate='no'>{t('profile.modals.address.referenceLabel')} {addressNowLocation.additional_info}</p>
                                                    </div>
                                                </div>
                                                <div className='row d-flex justify-content-between align-items-center'>

                                                    <div className='d-flex justify-content-center align-items-center col-sm'>
                                                        <Badge className='w-100 p-2 m-1' onClick={() => (setModalcreateAddressClient(false), setShowModalAddress(true), getAddressClientNow(), valueAddresLength())} bg="warning" text="dark">
                                                            <i class="uil uil-edit"> {t('profile.modals.address.changeAddress')}</i>
                                                        </Badge>
                                                    </div>
                                                    <div className='d-flex justify-content-center align-items-center col-sm'>
                                                        <Badge className='w-100 p-2 m-1' onClick={() => (deleteClientAddress())} bg="danger" text="white">
                                                            <i class="uil uil-trash"> {t('common.remove')}</i>
                                                        </Badge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </label>
                            </div>
                        </> : <>
                            {/* No address selected */}
                            <div className='col-12 col-md-12 p-2' onClick={() => (setShowModalAddress(true), getAddressClientNow())} role='button'>
                                <div className="card-directions-restaurant">
                                    <div className="d-flex justify-content-center align-items-center opacity-50 text-muted">
                                        <animated-icons
                                            src="https://animatedicons.co/get-icon?name=Distance&style=minimalistic&token=18f636dc-626c-433b-bc56-b868ff427698"
                                            trigger="click"
                                            attributes='{"variationThumbColour":"#FFFFFF","variationName":"Normal","variationNumber":1,"numberOfGroups":1,"backgroundIsGroup":false,"strokeWidth":2,"defaultColours":{"group-1":"#000000","background":"#FFFFFF"}}'
                                            height="80"
                                            width="80"
                                        ></animated-icons>
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <p class="opacity-50 text-center">{t('profile.modals.address.noAddressSelected')} <br></br> {t('profile.modals.address.selectHere')}</p>
                                    </div>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>

            {/* Address Modal */}
            <Modal
                centered
                className='modal-dialog-kk'
                size="lg"
                show={showModalAddess}
                onHide={() => (setShowModalAddress(false), setModalcreateAddressClient(false))}>
                <Modal.Body className='payment-container-ecommerce'>
                    <section className='rounded-4'>

                        <div className="d-flex justify-content-between">
                            <h2 className="text-theme h4">{t('profile.modals.address.chooseTitle')} </h2>
                            <button
                                onClick={() => (setShowModalAddress(false), setModalcreateAddressClient(false))}
                                type="button"
                                class="btn btn-light btn-circle shadow-sm"
                                data-bs-dismiss="modal"
                                aria-label={t('common.close')}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className='scale-up-top mt-2'>

                            <div className='d-flex justify-content-between w-100 gap-2'>
                                <button className='btn btn-outline-primary rounded-pill p-0 border-0' onClick={() => handlerLocation()}>
                                    <span className='d-flex align-items-center fw-bold px-3 py-1'> <i class="uil uil-location-pin-alt"> </i> {t('profile.modals.address.currentLocation')}  </span>
                                </button>
                                <button className='btn btn-outline-primary rounded-pill p-0 border-0' onClick={() => setModalcreateAddressClient(true)}>
                                    <span className='d-flex align-items-center fw-bold px-3 py-1'> <i class="uil uil-book-medical"> </i> {t('profile.modals.address.createAddress')} </span>
                                </button>
                            </div>
                            <ModalCreateAddressClient modalcreateAddressClient={modalcreateAddressClient} setModalcreateAddressClient={setModalcreateAddressClient} getAddressClientNow={getAddressClientNow} handleSelectAddress={handleSelectAddress}></ModalCreateAddressClient>
                            <div className='container row justify-item-center'>
                                {addressClient.length > 0 ? <>
                                    {viewAddress()}
                                </> : <>
                                    <div className='col-12 col-md-12 p-2' onClick={() => setModalcreateAddressClient(true)}>
                                        {/* Card */}
                                        <label className="w-100">
                                            <span className="plan-details">

                                                <div className='m-2 opacity-50'>
                                                    <div className="d-flex justify-content-center align-items-center"><i class="uil uil-location-pin-alt" style={{ fontSize: "2.5rem" }}></i> </div>
                                                    <div className=" d-grid">
                                                        <p className="text-center fw-bold">{t('profile.modals.address.noAddressesYet')}</p>

                                                        <span className='text-center text-primary w-100' role='button'>
                                                            {t('profile.modals.address.clickToCreate')}
                                                        </span>
                                                    </div>
                                                </div>

                                            </span>
                                        </label>
                                    </div>
                                </>}
                            </div>
                        </div>
                        <div className='text-muted text-center'>
                            <i className="uil uil-info-circle me-2"></i>
                            {t('profile.modals.address.selectThanks')}
                        </div>
                    </section>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalAddressClient